import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getActionsAppsApiClient } from "@shared/apis/sidekick/api-factories";
import { GET_CONNECTED_APPS_QUERY_KEY } from "./useGetActionsApps";

type Props = {
  onSuccess?: () => void;
};

export const useDisconnectActionsApp = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getActionsAppsApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async ({ appId }: { appId: string }) => {
      return api.appsControllerDisconnectApp({
        id: appId,
      });
    },
    onSuccess: async () => {
      onSuccess?.();
      queryClient.invalidateQueries({
        queryKey: [GET_CONNECTED_APPS_QUERY_KEY],
      });
    },
    onError: (error, { appId }) => {
      console.error(`Failed to disconnect app ${appId}`, error);
    },
  });

  return mutation;
};
